import { jsx as _jsx } from "react/jsx-runtime";
import "reflect-metadata";
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'react-tooltip/dist/react-tooltip.css';
import './presentation/components/css/lightpick.css';
import 'react-day-picker/style.css';
import './presentation/components/search_bar/form/dateRangePicker.scss';
import AppSearchBar from "./AppSearchBar";
import { initSentry } from "./infrastructure/sentry/sentryConfig";
initSentry("search-bar");
const containerId = 'search-bar';
let mounted = false;
let observer = null;
const renderApp = () => {
    if (mounted)
        return true;
    const container = document.getElementById(containerId);
    if (!container)
        return false;
    const root = ReactDOM.createRoot(container);
    root.render(_jsx(React.StrictMode, { children: _jsx(AppSearchBar, {}) }));
    mounted = true;
    if (observer)
        observer.disconnect();
    document.removeEventListener('DOMContentLoaded', renderApp);
    return true;
};
if (!renderApp()) {
    observer = new MutationObserver(() => {
        renderApp();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', renderApp);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
